import { addMinutes } from 'date-fns';

import { DATE } from 'mocks/server/utils/constants';

export const statusHistory = [
  {
    value: 2,
    state: 'LOW_DELIVERY',
    time: addMinutes(DATE, -10).getTime(),
  },
  {
    value: 2,
    state: 'IN_ERROR',
    time: addMinutes(DATE, -20).getTime(),
  },
  {
    value: 2,
    state: 'OK',
    time: addMinutes(DATE, -30).getTime(),
  },
  {
    value: 2,
    state: 'LOW_DELIVERY',
    time: addMinutes(DATE, -40).getTime(),
  },
  {
    value: 2,
    state: 'MIA',
    time: addMinutes(DATE, -45).getTime(),
  },
  {
    value: 2,
    state: 'DEACTIVATED',
    time: addMinutes(DATE, -120).getTime(),
  },
  {
    value: 2,
    state: 'OK',
    time: 1722867101000,
  },
  {
    value: 2,
    state: 'LOW_DELIVERY',
    time: 1722888913000,
  },
];
